import { Helmet } from "react-helmet-async";
export function SEO({ title = "Maajjal" }: { title?: string }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta property="og:title" name="og:title" content={title} />
      <meta name="twitter:title" property="twitter:title" content={title} />
    </Helmet>
  );
}
